import { MetricFormat } from 'app/apps/studio/app/models/dashboard.model';

const SUPPORTED_FORMATS = new Set(['currency', 'decimal', 'percent']);

export function resolveDashboardMetricFormat(
  metricName: string,
  baseFormat: any,
  dataset: string | undefined,
  dashboardMetricFormats: MetricFormat[] = [],
) {
  const formatType = typeof baseFormat === 'object' ? (baseFormat?.format || 'number') : (baseFormat || 'number');
  if (!SUPPORTED_FORMATS.has(formatType)) {
    return baseFormat;
  }

  const metricFormat = dashboardMetricFormats?.find(f => f.metric === metricName && f.dataset === dataset);
  if (!metricFormat || metricFormat.decimalPlaces === null || metricFormat.decimalPlaces === undefined) {
    return baseFormat;
  }

  const base = typeof baseFormat === 'object' && baseFormat ? baseFormat : {};
  return { ...base, format: formatType, decimal_places: metricFormat.decimalPlaces };
}
